import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const TeachingDialogActions = ({
  onCancel,
  onConfirm,
  confirmText,
  cancelText,
  isSubmitting = false,
  isDisabled = false,
  confirmVariant = "contained",
  cancelVariant = "outlined",
  showCancel = true,
  showConfirm = true,
}) => {
  return (
    <>
      {showCancel && (
        <Button
          variant={cancelVariant}
          onClick={onCancel}
          disabled={isSubmitting}
          sx={{ minWidth: 120 }}
        >
          {cancelText || <FormattedMessage id="general.cancel" defaultMessage="Cancel" />}
        </Button>
      )}
      {showConfirm && (
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          disabled={isSubmitting || isDisabled}
          startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
          sx={{ 
            minWidth: 180,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1.5,
          }}
        >
          {isSubmitting ? (
            <FormattedMessage id="teacher.submitting" defaultMessage="Submitting..." />
          ) : (
            confirmText || <FormattedMessage id="general.save" defaultMessage="Save" />
          )}
        </Button>
      )}
    </>
  );
};

TeachingDialogActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmText: PropTypes.node,
  cancelText: PropTypes.node,
  isSubmitting: PropTypes.bool,
  isDisabled: PropTypes.bool,
  confirmVariant: PropTypes.string,
  cancelVariant: PropTypes.string,
  showCancel: PropTypes.bool,
  showConfirm: PropTypes.bool,
};
